import LessonReinforce from './component.jsx'
export default LessonReinforce
